import { useEffect } from "react";
import { CommonStringLabels } from "../../util/Strings";
import "../../styles/common-components/Toast.css";

function Toast({ message, type = "info", duration = 3000, onClose }) {
  useEffect(() => {
    if (!message) {
      return undefined;
    }

    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) {
    return null;
  }

  return (
    <div className="cx-toast-container" aria-live="polite">
      <div className={`cx-toast cx-toast--${type}`} role="status">
        <span className="cx-toast-message">{message}</span>
        <button
          type="button"
          className="cx-toast-close"
          onClick={onClose}
          aria-label={CommonStringLabels.dismissNotification}
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default Toast;
